import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <div className="bg-black border border-[#39FF14]/30 rounded-2xl p-6 flex flex-col gap-4" data-id="element-355">
      <div className="flex items-center gap-3" data-id="element-356">
        <div className="w-12 h-12 rounded-full bg-[#39FF14]/20 border border-[#39FF14]/40 flex items-center justify-center text-[#39FF14] font-black text-sm flex-shrink-0" data-id="element-357">
          {initials}
        </div>
        <div data-id="element-358">
          <div className="text-[#39FF14] text-sm" data-id="element-359">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-360">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-361">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-362">"{quote}"</p>
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-363">
      <div className="max-w-5xl mx-auto" data-id="element-364">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-365">
          Lo que dicen los docentes de Português
          <br data-id="element-366" />
          <span className="text-[#39FF14]" data-id="element-367">que ya tienen su MegaPack:</span>
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-368">
          +800 docentes de Argentina ya lo usan
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-369">
          <TestimonialCard initials="MG" stars={5} quote="Compré el MegaPack un domingo a la noche. El lunes tenía todo el año de Português organizado. Las secuencias didácticas son exactamente lo que necesitaba." name="Mariela G." location="Córdoba" level="Docente de Português" data-id="element-370" />
          <TestimonialCard initials="FL" stars={5} quote="Lo que más valoro es que está organizado por nivel y en Português Brasileiro, no de Portugal. Mis alumnos finalmente entienden por qué estudian este idioma." name="Fernando L." location="Tucumán" level="Docente de Português" data-id="element-371" />
          <TestimonialCard initials="LP" stars={5} quote="Como profe lo que más me cambió fue el tomo de Fluência e Cultura. Mis alumnos por fin enganchan con la clase porque el contenido los conecta con temas reales." name="Laura P." location="Rosario" level="Docente de Português" data-id="element-372" />
          <TestimonialCard initials="PA" stars={5} quote="Los comunicados del Bono 5 me parecieron una tontería hasta que los usé. El primer domingo que respondí a una familia complicada con el mensaje del banco... fue un alivio." name="Pablo A." location="Neuquén" level="Docente de Português" data-id="element-373" />
          <TestimonialCard initials="SC" stars={5} quote="Tenía miedo de que fuera material genérico. Pero cuando abrí el Tomo 1, encontré exactamente lo que le falta al alumno argentino: la comparación sistemática entre español y portugués." name="Sofía C." location="La Plata" level="Docente de Português" data-id="element-374" />
          <TestimonialCard initials="RM" stars={5} quote="Los Role Plays del Bono 6 me cambiaron la forma de enseñar. En 10 minutos el curso entero estaba hablando en portugués sin vergüenza." name="Roberto M." location="Buenos Aires" level="Docente de Português" data-id="element-375" />
        </div>
      </div>
    </section>;
}